import React from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import cx from "classnames"
import { isEmpty, cloneDeep } from "lodash"
import { withRouter } from "react-router-dom"
import moment from "moment"
import "./index.scss"

import {
  getUserProfile,
  getUserEnrollments,
  getUserCertificates,
  updateProfile,
  getIDTemplate,
  verifyKYCPhoto,
  getCountryCode,
  getIBPChapters,
  getPHRegions,
  getMCLEProfile,
  updateMCLEProfile,
  getLawSchools,
  setKYCVerifyRetries,
  submitManualKYC,
  showConfirmModal,
  closeConfirmModal,
  updateProfilePhoto,
  showProfilePhotoModal,
  hideProfilePhotoModal,
  getWalletBalance,
  getWalletTransactions,
} from "store/user/actions"

import { resendEmail, logoutUser, changePassword } from "store/auth/action"

import Panel from "components/panel"
import PageContainer from "components/common/PageContainer"
import AccountCover from "components/cover"
import Avatar from "./components/avatar"
import ProfileStats from "./components/profile-stats"
import UploadPhotoModal from "./components/upload-modal"
import PersonalDetailsForm from "./basic-information"
import EmailForm from "./email-settings"
import MyCourses from "./courses"
import ClassCalendar from "./class-calendar"
import MyCertificates from "./certificates"
import ChangePasswordForm from "./change-password"
import AuthenticateForm from "./authenticate-id"
import MCLEProfile from "./mcle-profile"
import APTWallet from "./apt-wallet"
import { checkParams, isMatchPrimaryId, isIdVerified } from "helpers/util"
import { validateNumber } from "helpers/regex-validator"

import { SETTINGS, GOOGLE_SITE_KEY } from "constants/config"

import "styles/pages/my-account.scss"
import StatementModal from "components/common/StatementModal"
class MyAccount extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      userInfo: {
        first_name: "",
        middle_name: "",
        last_name: "",
        suffix: "",
        mobile_number: "",
        birthday: "",
        gender: "",
        type: "",
        school: "",
        course: "",
        country_code: "",
        license_number: "",
      },
      changePasswordForm: {
        old_password: "",
        new_password1: "",
        new_password2: "",
      },
      authenticateForm: {
        selfie_image: null,
        user_ids: [],
      },
      mcleProfile: {
        roll_number: "",
        ibp_chapter: "",
        ibp_lifetime_no: "",
        ibp_or_number: "",
        ibp_or_date: "",
        license_number: "",
        year_admitted: "",
        law_school: "",
        law_school_others: "",
        company: "",
        position: "",
        address: "",
        region: "",
        province: "",
        city: "",
        zip_code: "",
        home_address: "",
        work_address: "",
        telephone_number: "",
        fax_number: "",
        birth_place: "",
        civil_status: "",
      },
      isUploadModalOpen: false,
      authErrors: {},
      userErrors: {},
      authenticateErrors: {},
      currentTab: "profile", //DEFAULT,
      manualKYCSubmitted: false,
      isLicenseNA: false,
      showStatementModal: false,
    }

    this.myRef = React.createRef()
    this.inputFileRef = React.createRef()
    this.inputFileRef2 = React.createRef()
  }

  statementModalToggle = () => {
    this.setState((prevState) => ({
      showStatementModal: !prevState.showStatementModal,
    }))
  }

  handleAcceptDataPrivacy = () => {
    localStorage.setItem("data_privacy_notice", "1")
  }

  validateAuth = (fieldName) => {
    let authErrors = this.state.authErrors

    if (isEmpty(authErrors[fieldName])) {
      authErrors.fieldName = "This field is required"
    } else {
      delete authErrors[fieldName]
    }
    this.setState({ authErrors })
  }

  validateAuthOnSubmit(values) {
    const error = {}

    if (!values.old_password) {
      error.old_password = "Old password is required"
    }

    if (!values.new_password1) {
      error.new_password1 = "Password is required"
    } else if (values.new_password1.length < 8) {
      error.new_password1 = "Password must contain atleast 8 characters."
    } else if (validateNumber(values.new_password1)) {
      error.new_password1 = "Password must contain letters and numbers."
    }

    if (!values.new_password2) {
      error.new_password2 = "Password is required"
    }

    if (
      values.new_password1 &&
      values.new_password2 &&
      values.new_password1 !== values.new_password2
    ) {
      error.new_password2 = "Password not match."
    }

    return { error }
  }

  validateUserOnSubmit(values, role) {
    const { isLicenseNA } = this.state
    const error = {}

    if (!values.first_name) {
      error.first_name = "First Name is required"
    }
    if (!values.middle_name) {
      error.middle_name = "Middle Name is required"
    }
    if (!values.last_name) {
      error.last_name = "Last Name is required"
    }
    if (!values.mobile_number) {
      error.mobile_number = "Mobile Number is required"
    }
    if (!values.country_code && values.mobile_number) {
      error.mobile_number = "Country Code is required"
    }
    if (
      role === "ST" &&
      (!values.birthday || values.birthday === "Invalid date")
    ) {
      error.birthday = "Birthday is required"
    }
    if (role === "ST" && !values.gender) {
      error.gender = "Gender is required"
    }
    if (role === "ST" && !values.type) {
      error.type = "Type is required"
    }

    if (!values.license_number && !isLicenseNA) {
      error.license_number = "License Number is required"
    }

    return { error }
  }

  validateUser = (fieldName) => {
    let userErrors = this.state.userErrors

    if (!isEmpty(userErrors[fieldName])) {
      delete userErrors[fieldName]
    }
    this.setState({ userErrors })
  }

  componentDidMount() {
    const {
      location: { pathname },
      auth: { isAuthorized, userId, role },
      getUserProfile,
      getUserEnrollments,
      getUserCertificates,
      logoutUser,
      getIDTemplate,
      getCountryCode,
      getMCLEProfile,
      getIBPChapters,
      getPHRegions,
      getLawSchools,
      getWalletBalance,
      getWalletTransactions,
    } = this.props

    if (isAuthorized) {
      let currentPath = pathname.split("/")
      if (currentPath[1] === "student" && !isEmpty(currentPath[2])) {
        this.setState({ currentTab: currentPath[2] })
      }

      let data = {
        pageNumber: `page=1`,
        rowsPerPage: `perpage=6`,
      }

      getIDTemplate()
      getUserProfile({ userId: userId, role })
      getMCLEProfile({ id: userId })
      getUserEnrollments({ userId: userId, data: checkParams(data) })
      getUserCertificates({ userId: userId, data: checkParams(data) })
      getCountryCode()
      getIBPChapters()
      getPHRegions()
      getLawSchools()
      getWalletBalance()
      getWalletTransactions()

      this.checkKYCSubmissions()
    } else {
      logoutUser()
    }
  }

  handleDisplayRating(userDetails) {
    let rating = 0
    let avaraterating = userDetails?.average_rating + Number.EPSILON
    rating = Math.round(avaraterating * 100) / 100
    return rating || 0
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname: prevPath },
      user: {
        userDetails: prevUserDetails,
        errors: prevUserErrors,
        mcleProfile: prevMcleProfile,
        isSubmitting: prevIsSubmitting,
      },
      auth: { errors: prevAuthErrors },
      school: {
        isLoading: prevIsLoadingSchoolData,
        schoolData: prevSchoolData,
      },
    } = prevProps

    const {
      location: { pathname },
      user: {
        userDetails,
        errors: userErrors,
        mcleProfile,
        isSubmitting,
        kycError,
      },
      auth: { errors },
      school: { schoolData, isLoading: isLoadingSchoolData },
    } = this.props

    const {
      userInfo,
      authenticateForm,
      mcleProfile: mcleProfileState,
      manualKYCSubmitted,
      currentTab,
      authenticateErrors,
    } = this.state

    const { selfie: userSelfie, user_ids: submittedIds } = userDetails

    if (prevUserDetails !== userDetails) {
      this.setState({
        userInfo: {
          ...userInfo,
          first_name: userDetails.first_name,
          middle_name: userDetails.middle_name,
          last_name: userDetails.last_name,
          suffix: userDetails.suffix,
          country_code: userDetails.country_code,
          mobile_number: userDetails.mobile_number,
          birthday: userDetails.birthday,
          gender: userDetails.gender,
          type: userDetails.type,
          school: userDetails.school,
          course: userDetails.course,
          email: userDetails.email,
          role: userDetails.role,
          username: userDetails.username,
          license_number: userDetails.license_number,
        },
        authenticateForm: {
          ...authenticateForm,
          user_ids: !isEmpty(submittedIds)
            ? cloneDeep(submittedIds)
            : [{ photo_id: null, template: null, new_id: true }],
          selfie_image: !isEmpty(submittedIds) ? userSelfie : "",
        },
        isLicenseNA: userDetails.license_number ? false : true,
        isMCLENA: false,
      })
    }

    if (prevMcleProfile !== mcleProfile) {
      const isMCLENotApplicable =
        !mcleProfile.roll_number &&
        !mcleProfile.ibp_chapter &&
        !mcleProfile.law_school

      this.setState({
        mcleProfile: {
          ...mcleProfileState,
          roll_number: mcleProfile.roll_number || "",
          ibp_chapter: mcleProfile.ibp_chapter || "",
          ibp_lifetime_no: mcleProfile.ibp_lifetime_no || "",
          ibp_or_number: mcleProfile.ibp_or_number || "",
          ibp_or_date: mcleProfile.ibp_or_date || "",
          license_number: mcleProfile.license_number || "",
          year_admitted: mcleProfile.year_admitted || "",
          law_school: mcleProfile.law_school || "",
          law_school_others: mcleProfile.law_school_others || "",
          company: mcleProfile.company || "",
          position: mcleProfile.position || "",
          address: mcleProfile.address || "",
          region: mcleProfile.region || "",
          province: mcleProfile.province || "",
          city: mcleProfile.city || "",
          zip_code: mcleProfile.zip_code || "",
          home_address: mcleProfile.home_address || "",
          work_address: mcleProfile.work_address || "",
          telephone_number: mcleProfile.telephone_number || "",
          fax_number: mcleProfile.fax_number || "",
          birth_place: mcleProfile.birth_place || "",
          civil_status: mcleProfile.civil_status || "",
        },
        isMCLENA: isMCLENotApplicable,
      })
    }

    if (currentTab === "authenticate-id") {
      const { user_ids = [] } = authenticateForm

      if (
        !isSubmitting &&
        isSubmitting !== prevIsSubmitting &&
        !isEmpty(kycError) &&
        !manualKYCSubmitted
      ) {
        if (this.inputFileRef?.current) {
          this.inputFileRef.current.value = ""
        }
        if (this.inputFileRef2?.current) {
          this.inputFileRef2.current.value = ""
        }

        Object.keys(kycError).forEach((code) => {
          let errorField = false
          if (code === "id0") {
            if (user_ids[0].new_id) {
              errorField = "id-image-0"
              //user_ids[0].photo_id = ""
            } else {
              errorField = "id-image-1"
              //user_ids[1].photo_id = ""
            }
          } else if (code === "id1") {
            errorField = "id-image-1"
            //user_ids[1].photo_id = ""
          } else if (code === "selfie") {
            errorField = "selfie_image"
            //authenticateForm["selfie_image"] = ""
          }

          if (errorField) {
            authenticateErrors[errorField] = kycError[code]
          }
        })

        this.setState({
          authenticateErrors,
          authenticateForm,
        })
      }

      if (
        !isLoadingSchoolData &&
        isLoadingSchoolData !== prevIsLoadingSchoolData &&
        !isEmpty(schoolData)
      ) {
        const isSecondIdRequired = this.isSecondIdRequired()
        const hasSecondId = !isEmpty(user_ids[1])
        if (isSecondIdRequired && !hasSecondId) {
          user_ids[1] = { photo_id: null, template: null, new_id: true }
        } else if (!isSecondIdRequired && hasSecondId) {
          user_ids.splice(1)
        }
      }
    }

    if (
      currentTab === "profile" &&
      prevSchoolData &&
      prevSchoolData !== schoolData
    ) {
      this.setState({
        showStatementModal:
          schoolData?.config?.products?.show_data_privacy_notice,
      })
      const isDataPrivacyShown = localStorage.getItem("data_privacy_notice")
      if (
        isDataPrivacyShown === "1" &&
        schoolData?.config?.products?.show_data_privacy_notice
      ) {
        this.setState({
          showStatementModal: false,
        })
      } else if (
        isDataPrivacyShown !== "1" &&
        schoolData?.config?.products?.show_data_privacy_notice
      ) {
        this.setState({
          showStatementModal: true,
        })
      } else {
        localStorage.removeItem("data_privacy_notice")
      }
    }
    if (prevPath !== pathname) {
      let currentPath = pathname.split("/")
      if (currentPath[1] === "student" && !isEmpty(currentPath[2])) {
        this.setState({ currentTab: currentPath[2] })
      }
    }

    if (errors !== prevAuthErrors) {
      this.setState({ authErrors: errors })
    }

    if (userErrors !== prevUserErrors) {
      this.setState({ userErrors: userErrors })
    }
  }

  isSecondIdRequired = (value = false) => {
    const {
      school: { schoolData },
      user: { idTemplate },
    } = this.props
    const { authenticateForm = {} } = this.state

    const { config: schoolConfig = {} } = schoolData
    const schoolPrimaryId = schoolConfig?.products?.primary_id || false

    const { user_ids = [] } = authenticateForm
    const currentId = value || user_ids[0]?.template

    if (!schoolPrimaryId || !currentId) {
      return false
    } else {
      return !isMatchPrimaryId(idTemplate, schoolPrimaryId, currentId)
    }
  }

  checkKYCSubmissions = () => {
    const {
      auth: { userId },
    } = this.props

    const nextManualKYC = localStorage.getItem(`KYCManual-${userId}`)
    const manualKYCSubmitted = nextManualKYC

    this.setState({ manualKYCSubmitted })
  }

  handleChangePersonalDetails = (e) => {
    const { userInfo } = this.state
    const { name, value } = e.currentTarget

    this.setState(
      {
        userInfo: {
          ...userInfo,
          [name]: value,
        },
      },
      () => {
        this.validateUser(name)
      }
    )
  }

  handleSelectPersonalDetails = (data) => {
    const { userInfo } = this.state
    const { name, value } = data

    this.setState(
      {
        userInfo: {
          ...userInfo,
          [name]: value,
        },
      },
      () => {
        this.validateUser(name)
      }
    )
  }

  handleChangeDate = (date) => {
    const { userInfo } = this.state
    this.setState(
      {
        userInfo: {
          ...userInfo,
          birthday: date,
        },
      },
      () => {
        this.validateUser("birthday")
      }
    )
  }

  handleChangeCountry = (data) => {
    const { userInfo } = this.state
    this.setState(
      {
        userInfo: {
          ...userInfo,
          country_code: data.value,
        },
      },
      () => {
        this.validateUser("country_code")
      }
    )
  }

  handleChangePassword = (e) => {
    const { changePasswordForm } = this.state
    const { name, value } = e.currentTarget
    this.setState(
      {
        changePasswordForm: {
          ...changePasswordForm,
          [name]: value,
        },
      },
      () => {
        this.validateAuth(name)
      }
    )
  }

  handleToggleTab = (currentTab) => {
    const {
      getIDTemplate,
      getUserEnrollments,
      getUserCertificates,
      auth: { userId },
    } = this.props

    let data = {
      pageNumber: `page=1`,
      rowsPerPage: `perpage=6`,
    }

    if (currentTab === "authenticate-id") {
      getIDTemplate()
    } else if (currentTab === "courses") {
      getUserEnrollments({ userId: userId, data: data })
    } else if (currentTab === "certificates") {
      getUserCertificates({ userId: userId, data: data })
    } else if (currentTab === "profile") {
      getCountryCode()
    } else if (currentTab === "mcle-profile") {
      getIBPChapters()
      getPHRegions()
    }
    this.setState({ authErrors: {} })
    this.setState({ currentTab: currentTab })
  }

  handleChangeIDType = (data, idx = 0) => {
    const { authenticateForm = {}, authenticateErrors } = this.state
    const { user_ids = [] } = authenticateForm
    const { value } = data

    const updatedIds = cloneDeep(user_ids)

    if (idx === 0) {
      if (!this.isSecondIdRequired(value)) {
        updatedIds.splice(1)
      } else if (isEmpty(updatedIds[1])) {
        updatedIds[1] = {
          photo_id: null,
          template: null,
          new_id: true,
        }
      }
    }

    if (!isEmpty(updatedIds[idx])) {
      updatedIds[idx].template = value
    } else {
      updatedIds[idx] = {
        template: value,
      }
    }

    this.setState({
      authenticateForm: {
        ...authenticateForm,
        user_ids: updatedIds,
      },
    })

    const errorFieldCode = `id-template-${idx}`
    if (authenticateErrors[errorFieldCode]) {
      delete authenticateErrors[errorFieldCode]
    }

    this.setState({ authenticateErrors })
  }

  handleScreenShot = () => {
    const { authenticateForm, authenticateErrors: authError } = this.state
    let authenticateErrors = authError
    var screenshot = this.myRef.current.getScreenshot()
    this.setState({
      authenticateForm: {
        ...authenticateForm,
        selfie_image: screenshot,
      },
    })
    if (authenticateErrors.selfie_image) {
      delete authenticateErrors.selfie_image
    }
    this.setState({ authenticateErrors })
    if (this.myRef.current) {
      this.myRef.current.video.pause()
    }
  }

  handleRetake = () => {
    const { authenticateForm } = this.state
    if (this.myRef.current) {
      this.myRef.current.video.play()
      this.setState({
        authenticateForm: {
          ...authenticateForm,
          selfie_image: null,
        },
      })
    }
  }

  handleChangeImage = (e, idx = 0) => {
    e.preventDefault()
    const { authenticateForm, authenticateErrors: authError } = this.state
    const { user_ids = [] } = authenticateForm

    const updatedIds = cloneDeep(user_ids)

    let file = e.target.files[0]
    let reader = new FileReader()
    let authenticateErrors = authError

    const fileType = file?.type
    const validImageTypes = ["image/gif", "image/jpeg", "image/png"]
    const errorFieldCode = `id-image-${idx}`
    let errors = {}

    if (!validImageTypes.includes(fileType)) {
      errors[errorFieldCode] = "Invalid image file."
      updatedIds[idx].photo_id = null

      this.setState({
        authenticateErrors: errors,
        authenticateForm: {
          ...authenticateForm,
          user_ids: updatedIds,
        },
      })
    } else {
      if (file) {
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          if (updatedIds.some((item) => item.photo_id === reader.result)) {
            errors[errorFieldCode] = "Duplicate image selected."
          } else if (!isEmpty(updatedIds[idx])) {
            updatedIds[idx].photo_id = reader.result
          } else {
            updatedIds[idx] = {
              photo_id: reader.result,
            }
          }
          if (isEmpty(errors)) {
            this.setState({
              authenticateForm: {
                ...authenticateForm,
                user_ids: updatedIds,
              },
            })
            if (authenticateErrors[errorFieldCode]) {
              delete authenticateErrors[errorFieldCode]
            }
          } else {
            authenticateErrors = errors
          }
          this.setState({ authenticateErrors })
        }
      }
    }
  }

  handleImageClick = (e, index = 0) => {
    e.preventDefault()
    e.stopPropagation()
    if (index > 0) {
      this.inputFileRef2.current.click()
    } else {
      this.inputFileRef.current.click()
    }
  }

  handleResendEmail = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(GOOGLE_SITE_KEY, { action: "submit" })
        .then((token) => {
          this.props.resendEmail({
            "g-recaptcha-response": token,
          })
        })
    })
  }

  submitKYCPhoto = (manualVerification = false) => {
    const {
      user: { userDetails = {} },
      school: { schoolData = {} },
      verifyKYCPhoto,
    } = this.props
    const { user_ids: submittedIds = [] } = userDetails || {}
    const { authenticateForm } = this.state
    const { user_ids = [], selfie_image } = authenticateForm

    let errors = {}

    user_ids.forEach((item, idx) => {
      if (!item.submitted && !item.verified) {
        if (
          isEmpty(item.photo_id) ||
          submittedIds[idx]?.photo_id === item.photo_id
        ) {
          errors[`id-image-${idx}`] = "ID image is required"
        }

        if (!item.template || submittedIds[idx]?.template === item.template) {
          errors[`id-template-${idx}`] = "Template ID is required"
        }
      }
    })

    if (!selfie_image || selfie_image === userDetails?.selfie) {
      errors["selfie_image"] = "Selfie image is required"
    }

    if (isEmpty(errors)) {
      const payload = {
        school: schoolData?.id,
        submit: manualVerification,
        selfie: selfie_image,
        user_ids: user_ids
          ?.filter((item) => !item.submitted && !item.verified)
          ?.map((item) => {
            return {
              id: item.photo_id,
              template: item.template,
            }
          }),
      }
      verifyKYCPhoto(payload)
    } else {
      this.setState({
        authenticateErrors: errors,
      })
    }
  }

  submitProfilePhoto = (photo) => {
    const {
      auth: { studentId },
      updateProfilePhoto,
    } = this.props

    const formData = new FormData()
    formData.append("photo", photo)

    updateProfilePhoto(studentId, formData)
  }

  submitManualKYC = () => {
    const {
      school: { schoolData = {} },
      submitManualKYC,
    } = this.props

    submitManualKYC(schoolData.id)
  }

  submitChangePassword = () => {
    const { changePassword } = this.props
    const { changePasswordForm } = this.state

    const { error } = this.validateAuthOnSubmit(changePasswordForm)

    if (!isEmpty(error)) {
      this.setState({ authErrors: error })
    } else {
      changePassword(changePasswordForm)
    }
  }

  submitUserProfile = () => {
    const {
      updateProfile,
      auth: { userId, role },
    } = this.props

    const { userInfo } = this.state

    const { error } = this.validateUserOnSubmit(userInfo, role)
    if (!isEmpty(error)) {
      this.setState({ userErrors: error })
    } else {
      updateProfile({ id: userId, data: userInfo, role })
    }
  }

  submitMCLEProfile = (payload) => {
    const {
      updateMCLEProfile,
      auth: { userId },
    } = this.props

    updateMCLEProfile({ id: userId, data: payload })
  }

  toggleLicenseNotApplicable = (toggle) => {
    if (toggle === "license") {
      const { isLicenseNA, userInfo } = this.state
      this.setState({
        isLicenseNA: !isLicenseNA,
        userInfo: {
          ...userInfo,
          license_number: isLicenseNA ? "" : userInfo?.license_number,
        },
      })
      this.validateUser("license_number")
    } else {
      const { isMCLENA } = this.state
      this.setState({
        isMCLENA: !isMCLENA,
      })
    }
  }

  displayCurrentTabContainer = (tab) => {
    const {
      userInfo,
      changePasswordForm,
      authenticateForm,
      mcleProfile,
      authErrors,
      userErrors,
      authenticateErrors,
      manualKYCSubmitted,
      isLicenseNA,
      isMCLENA,
    } = this.state

    const {
      auth: { isLoading, role },
      user: {
        isSubmitting,
        userDetails,
        idTemplate = [],
        countryCode,
        lawSchools,
        kycVerifyRetries,
        isLoadingID,
        walletDetails,
        walletTransactions,
        kycError,
        phRegions,
        ibpChapters,
      },
      school: { schoolData },
    } = this.props
    const { config: schoolConfig = {} } = schoolData

    switch (tab) {
      case "authenticate-id":
        const retryExceeded = kycVerifyRetries >= SETTINGS.KYC_MAX_RETRIES
        const schoolPrimaryId = schoolConfig?.products?.primary_id || false

        return (
          <AuthenticateForm
            loading={isSubmitting}
            isLoadingOptions={isLoadingID}
            isSecondIdRequired={this.isSecondIdRequired()}
            options={isLoadingID ? [] : idTemplate}
            authForm={authenticateForm}
            handleChangeType={this.handleChangeIDType}
            handleChangeImage={this.handleChangeImage}
            forwardRef={this.myRef}
            inputFileRef={[this.inputFileRef, this.inputFileRef2]}
            handleImageClick={this.handleImageClick}
            handleScreenShot={this.handleScreenShot}
            handleRetake={this.handleRetake}
            handleSubmitForVerification={this.submitKYCPhoto}
            handleManualVerification={this.submitManualKYC}
            userKYC={userDetails}
            retryExceeded={retryExceeded}
            manualKYCSubmitted={manualKYCSubmitted}
            errors={authenticateErrors}
            kycError={kycError}
            schoolPrimaryId={schoolPrimaryId}
          />
        )
      case "email":
        return (
          <EmailForm
            email={userDetails.email}
            isVerified={userDetails.is_verified}
            resendEmail={this.handleResendEmail}
            errors={authErrors}
          />
        )
      case "courses":
        return <MyCourses />
      case "classes":
        return <ClassCalendar />
      case "certificates":
        return <MyCertificates />
      case "change-password":
        return (
          <ChangePasswordForm
            old_password={changePasswordForm.old_password}
            new_password1={changePasswordForm.new_password1}
            new_password2={changePasswordForm.new_password2}
            changePassword={this.submitChangePassword}
            handleChange={this.handleChangePassword}
            error={authErrors}
            loading={isLoading}
          />
        )
      case "mcle-profile":
        return (
          <MCLEProfile
            mcleProfile={mcleProfile}
            schoolData={schoolData}
            lawSchools={lawSchools}
            handleSave={this.submitMCLEProfile}
            loading={isLoading}
            phRegions={phRegions}
            ibpChapters={ibpChapters}
            isMCLENA={isMCLENA}
            toggleMCLEApplicable={() => {
              this.toggleLicenseNotApplicable("MCLE")
            }}
          />
        )
      case "apt-wallet":
        return (
          <APTWallet
            walletDetails={walletDetails}
            walletTransactions={walletTransactions}
            changePassword={this.submitChangePassword}
            handleChange={this.handleChangePassword}
            error={authErrors}
            loading={isLoading}
          />
        )
      default:
        let data = userInfo
        data.birthday = moment(data.birthday).format("YYYY-MM-DD")
        let tempCountryCode = countryCode.map((code) => {
          code.label = `${code.name}(+${code.country_code})`
          code.value = `${code.country_code}`
          return code
        })

        return (
          <PersonalDetailsForm
            userInfo={userInfo}
            handleChange={this.handleChangePersonalDetails}
            handleSelect={this.handleSelectPersonalDetails}
            handleChangeDate={this.handleChangeDate}
            handleSave={this.submitUserProfile}
            loading={isSubmitting}
            error={userErrors}
            countryCode={tempCountryCode}
            handleChangeCountry={this.handleChangeCountry}
            role={role}
            schoolConfig={schoolConfig}
            isLicenseNA={isLicenseNA}
            toggleLicenseNotApplicable={() =>
              this.toggleLicenseNotApplicable("license")
            }
          />
        )
    }
  }

  handleSelectPhoto = () => {
    const { showProfilePhotoModal } = this.props
    showProfilePhotoModal()
  }

  render() {
    const {
      user: {
        userDetails,
        isLoadingProfile,
        certificates,
        enrollments,
        isSubmitting,
        showProfilePhotoModal,
        errors,
      },
      school: {
        schoolColor,
        schoolData: { config, primary_color, data_privacy, consent_form },
      },
      auth: { role },
      hideProfilePhotoModal,
    } = this.props

    const { currentTab, showStatementModal } = this.state

    const { user_ids: submittedIds = [] } = userDetails
    const schoolPrimaryId = config?.products?.primary_id || false
    const kycVerified = isIdVerified(submittedIds, schoolPrimaryId)

    const hasAptCoins = config?.products?.apt_coins
    return (
      <PageContainer>
        <AccountCover
          title="My Account"
          currentPath="/student/profile"
          activeColor={primary_color} //replace with path props
        />
        <div className="account-container">
          <div className="account-header">
            <Panel pad="40">
              <div className="avatar">
                <Avatar
                  isLoading={isLoadingProfile}
                  profileDetails={userDetails}
                  schoolColor={schoolColor}
                  onEditPhoto={this.handleSelectPhoto}
                />
              </div>

              <h1 className="fullname">{userDetails?.full_name || "N/A"}</h1>
              <p className="email">{userDetails?.email || "N/A"}</p>
              <p className="mobile">
                {userDetails?.mobile_number
                  ? `+${userDetails?.country_code + userDetails?.mobile_number}`
                  : "N/A"}
              </p>

              <div className="profile-stats">
                <ProfileStats
                  value={enrollments?.count}
                  name="Courses"
                  color={schoolColor}
                />
                <ProfileStats
                  value={certificates?.count}
                  name="Certificates"
                  color={schoolColor}
                />
                <ProfileStats
                  value={this.handleDisplayRating(userDetails)}
                  name="Average Rating"
                  color={schoolColor}
                />
              </div>
            </Panel>
          </div>
          <div className="account-sidenav">
            <Panel pad="24">
              <button
                className={cx(
                  "button-custom",
                  currentTab === "profile" ? "active" : ""
                )}
                onClick={() => this.handleToggleTab("profile")}
              >
                Basic Profile
                <span
                  className={cx(
                    "icon",
                    userDetails?.step === "1" ? "warning" : "success"
                  )}
                >
                  <i
                    className={cx(
                      "fas",
                      userDetails?.step === "1"
                        ? "fa-exclamation-circle"
                        : "fa-check-circle"
                    )}
                  />
                </span>
              </button>

              {role === "ST" && config?.products?.mcle && (
                <button
                  className={cx(
                    "button-custom",
                    currentTab === "mcle-profile" ? "active" : ""
                  )}
                  onClick={() => this.handleToggleTab("mcle-profile")}
                >
                  MCLE Profile
                  <span
                    className={cx(
                      "icon",
                      userDetails?.info_submitted ? "success" : "warning"
                    )}
                  >
                    <i
                      className={cx(
                        "fas",
                        userDetails?.info_submitted
                          ? "fa-check-circle"
                          : "fa-exclamation-circle"
                      )}
                    />
                  </span>
                </button>
              )}

              {role === "ST" && config?.products?.kyc && (
                <button
                  className={cx(
                    "button-custom",
                    currentTab === "authenticate-id" ? "active" : ""
                  )}
                  onClick={() => this.handleToggleTab("authenticate-id")}
                >
                  Authenticate ID
                  <span
                    className={cx("icon", kycVerified ? "success" : "warning")}
                  >
                    <i
                      className={cx(
                        "fas",
                        kycVerified
                          ? "fa-check-circle"
                          : "fa-exclamation-circle"
                      )}
                    />
                  </span>
                </button>
              )}

              <button
                className={cx(
                  "button-custom",
                  currentTab === "email" ? "active" : ""
                )}
                onClick={() => this.handleToggleTab("email")}
              >
                Email Settings
                {userDetails.is_verified ? (
                  <span className="icon success">
                    <i className="fas fa-check-circle"></i>
                  </span>
                ) : (
                  <span className="icon warning">
                    <i className="fas fa-info-circle"></i>
                  </span>
                )}
              </button>
              {role === "ST" && (
                <button
                  className={cx(
                    "button-custom",
                    currentTab === "courses" ? "active" : ""
                  )}
                  onClick={() => this.handleToggleTab("courses")}
                >
                  My Courses
                </button>
              )}
              {role === "ST" && (
                <button
                  className={cx(
                    "button-custom",
                    currentTab === "classes" ? "active" : ""
                  )}
                  onClick={() => this.handleToggleTab("classes")}
                >
                  My Classes
                </button>
              )}
              {role === "ST" && (
                <button
                  className={cx(
                    "button-custom",
                    currentTab === "certificates" ? "active" : ""
                  )}
                  onClick={() => this.handleToggleTab("certificates")}
                >
                  My Certificates
                </button>
              )}
              <button
                className={cx(
                  "button-custom",
                  currentTab === "change-password" ? "active" : ""
                )}
                onClick={() => this.handleToggleTab("change-password")}
              >
                Change Password
              </button>
              {role === "ST" && hasAptCoins && (
                <button
                  className={cx(
                    "button-custom",
                    currentTab === "apt-wallet" ? "active" : ""
                  )}
                  onClick={() => this.handleToggleTab("apt-wallet")}
                >
                  APT Wallet
                </button>
              )}
            </Panel>
          </div>

          <div className="account-overview">
            {this.displayCurrentTabContainer(currentTab)}{" "}
          </div>
          <UploadPhotoModal
            isOpen={showProfilePhotoModal}
            onClose={hideProfilePhotoModal}
            userProfile={userDetails}
            isSubmitting={isSubmitting}
            onUpload={this.submitProfilePhoto}
            errors={errors}
          />

          <StatementModal
            isOpen={showStatementModal}
            closeModal={() => this.statementModalToggle()}
            title="DATA PRIVACY STATEMENT AND CONSENT FORM"
            consentLabel="I am confirming that I have read and accept the privacy policy and agree to the collection of my personal information as outlined."
            message={data_privacy + consent_form}
            onConfirm={() => {
              this.statementModalToggle()
              this.handleAcceptDataPrivacy()
            }}
          />
        </div>
      </PageContainer>
    )
  }
}
const mapStateToProps = (state) => ({
  school: state.schoolReducer,
  user: state.userReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserProfile,
      getUserEnrollments,
      getUserCertificates,
      logoutUser,
      updateProfile,
      resendEmail,
      changePassword,
      getIDTemplate,
      verifyKYCPhoto,
      getCountryCode,
      getMCLEProfile,
      updateMCLEProfile,
      getIBPChapters,
      getPHRegions,
      getLawSchools,
      setKYCVerifyRetries,
      submitManualKYC,
      showConfirmModal,
      closeConfirmModal,
      updateProfilePhoto,
      showProfilePhotoModal,
      hideProfilePhotoModal,
      getWalletBalance,
      getWalletTransactions,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(MyAccount)
